import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useThrottle } from "../../../../hooks/useThrottle"
import { useSearchByUsernameQuery } from "../../../../store/accountSlice"
import { BaseViewModel } from "./Base"
import type {
    SearchUsersViewModel,
    SearchUsersViewModelPros,
} from "./SearchUsersViewModelTypes"

export const GeneralViewModel = ({
    typingThrottle,
}: SearchUsersViewModelPros): SearchUsersViewModel => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const qParam = searchParams.get("q") ?? ""
    const [search, setSearch] = useState(qParam)

    useEffect(() => {
        if (search !== qParam) {
            setSearchParams({ q: search }, { replace: true })
        }
    }, [search, qParam, setSearchParams])

    const onGoBack = () => {
        navigate(-1)
    }

    const handleUserSelect = (username: string) => {
        navigate(`/messages/${username}`)
    }

    const throttledQParam = useThrottle(qParam, typingThrottle)

    const { data, isFetching, error } = useSearchByUsernameQuery(
        { term: throttledQParam },
        {
            skip: !throttledQParam,
        },
    )

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
    }

    const { listRef, source } = BaseViewModel()

    return {
        searchResults: {
            search,
            setSearch,
            isFetching,
            error,
            data,
        },
        listRef,
        source,
        handleSearchChange,
        handleUserSelect,
        handleGoBack: onGoBack,
    }
}
